module.exports = __webpack_public_path__ + "img/yishi8.7dc11766.jpg";